<div class="assoc-epe-row {{ epe.association_status }} project_{{ project_association_status }}"
     [ngClass]="{'not_approved': canHide()}">

  <div class="assoc-epe-left">
    <img class="profile-icon"
         src="https://hsbooster.eu{{ epe.picture }}"
         onerror="this.src='/assets/img/1177568.png'" alt="">

    <div *ngIf="(!auth.isEpe() || (auth.isEpe() && (auth.isCallManager() || auth.isProjectBoard() || auth.isAdmin()))) && !auth.isProject()"
         class="score-block">
      <div class="score-item">
        <span class="score-num">{{ epe.score }}</span>
        <span class="score-label">Score</span>
      </div>
      <div class="score-item">
        <span class="score-num">{{ epe.nvotes }}</span>
        <span class="score-label">N. votes</span>
      </div>
    </div>

    <div *ngIf="project_association_status == 'approved' && (auth.isEpe() || (auth.isProject() && !canHide()))"
         class="score-block">
      <div class="score-item">
        <span class="score-num">{{ meeting_form }}</span>
        <span class="score-label">steps completed</span>
      </div>
    </div>
  </div>

  <div class="assoc-epe-info">
    <div class="assoc-epe-name">
      <span *ngIf="epe.version == 'v2'">{{ epe.title }} </span>{{ epe.name }} {{ epe.surname }}
    </div>
    <div class="assoc-epe-meta" *ngIf="epe.organisation_type">{{ epe.organisation_type }}</div>
    <div class="assoc-epe-meta" *ngIf="epe.email">{{ epe.email }}</div>
    <div class="assoc-epe-level"
         *ngIf="epe['level'] && epe['level'] !== 'no-matching' && (!auth.isEpe() || (auth.isEpe() && (auth.isCallManager() || auth.isProjectBoard() || auth.isAdmin()))) && !auth.isProject()">
      <img src="/assets/img/{{ epe['level'] }}.png" alt="">
      {{ epe['level'] }} level matching
    </div>
  </div>

  <div class="assoc-epe-input" *ngIf="auth.isCallManager()">
    <input (click)="change(epe.application_id)" *ngIf="!helper.isEpeSelected(epe.application_id)" class="form-check-input" type="checkbox">
    <input (click)="change(epe.application_id)" *ngIf="helper.isEpeSelected(epe.application_id)"  class="form-check-input checked" type="checkbox">
  </div>
</div>
<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
